import React from 'react';

export default function CompanyOverview({ content }) {
  const { title, subtitle, description, image_url, features } = content || {};

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-brand font-semibold text-sm uppercase tracking-wider">{subtitle || 'Tentang Perusahaan'}</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mt-3 mb-6" style={{ fontFamily: "'Cabin', sans-serif" }}>{title || 'Kisah Kami'}</h2>
            <div className="prose prose-lg text-gray-600 max-w-none" dangerouslySetInnerHTML={{ __html: description || '<p>Klinnovac adalah perusahaan yang berdedikasi menghadirkan solusi pembersih ramah lingkungan berbasis eco-enzyme untuk rumah tangga dan industri.</p>' }} />
            {(features || []).length > 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                {features.map((f, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5" style={{ backgroundColor: 'rgba(0,207,255,0.1)' }}>
                      <svg className="w-5 h-5" style={{ color: '#66E0FF' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-sm">{f.title}</h4>
                      <p className="text-sm text-gray-500">{f.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-xl" style={{ backgroundColor: 'rgba(0,207,255,0.08)' }}>
              {image_url ? (
                <img src={image_url} alt={title || 'Company overview'} className="w-full h-80 object-cover" />
              ) : (
                <div className="w-full h-80 flex items-center justify-center" style={{ background: 'linear-gradient(135deg, rgba(0,207,255,0.2), rgba(0,200,232,0.2))' }}>
                  <span className="text-8xl">🏢</span>
                </div>
              )}
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand rounded-2xl hidden lg:flex items-center justify-center shadow-lg" style={{ backgroundColor: '#66E0FF' }}>
              <span className="text-4xl">🌿</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
